import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './_helpers/auth.guard';
import { messageRoutes } from './components/newmessages/messages.routes';
const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/home/home.module').then((m) => m.HomeModule),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./components/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'message',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/newmessages/messages.routes').then(
        (m) => m.messageRoutes
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./components/auth/auth.module').then((m) => m.AuthModule),
  },
  //   {
  //   path: 'messages',
  //   children: messageRoutes
  // },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
